import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import ChooseColumnsContainer from "containers/CreateWizard/Dataset/ChooseColumns";

import SelectDataWrapper from "components/UnifiedProject/SelectData/SelectDataWrapper";
import NextSelectDataWrapper from "components/Next/SelectData/SelectDataWrapper";
import SelectDataAdvanced from "components/UnifiedProject/SelectData/SelectDataAdvanced";
import AdvancedModelsContainer from "containers/UnifiedProject/AdvancedModels/AdvancedModels";

import SelectData from "containers/UnifiedProject/SelectData/SelectData";
import GalleryContainer from "containers/Gallery/Gallery";

import * as wizardReducer from "containers/Wizard/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as runReducer from "containers/Run/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as viewReducer from "containers/View/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as homeReducer from "containers/Home/reducer";

import { SELECT_DATA_ADVANCED_OPTIONS } from "containers/UnifiedProject/reducer";

import { isEnabled } from "utils/featureFlags";

class SelectDataWrapperContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  renderType(type) {
    const { aibleMode, options, dataset, runId } = this.props;

    // return <ChooseColumnsContainer {...this.props} id={runId} key={type} />;

    const selectedTab = options && options["selectedTab"];

    switch (selectedTab) {
      case undefined:
        return <ChooseColumnsContainer {...this.props} id={runId} key={type} />;

      case SELECT_DATA_ADVANCED_OPTIONS.CALCULATED_FIELDS:
        return <ChooseColumnsContainer {...this.props} isCalculated id={runId} key={type} />;

      case SELECT_DATA_ADVANCED_OPTIONS.ADVANCED_MODELS:
        return <AdvancedModelsContainer {...this.props} isCalculated id={runId} key={type} />;

      case SELECT_DATA_ADVANCED_OPTIONS.GALLERY:
        return <GalleryContainer isAdvanced isConsumer datasetId={dataset ? dataset.id : undefined} />;

      case SELECT_DATA_ADVANCED_OPTIONS.FIELDS:
      default:
        return <ChooseColumnsContainer {...this.props} id={runId} key={type} />;
    }
  }

  render() {
    const { isEditBlueprint, type, stepIndex, id, runId, isNext, dataset, isDataSelect } = this.props;

    return (
      <React.Fragment>
        {isNext ? (
          <NextSelectDataWrapper {...this.props}>
            <SelectData
              {...this.props}
              projectId={id}
              id={runId}
              key={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
            />
            {dataset && isEnabled("aible-explore") !== true && !isDataSelect && (
              <SelectDataAdvanced {...this.props}>
                {this.renderType(wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id)}
              </SelectDataAdvanced>
            )}
          </NextSelectDataWrapper>
        ) : (
          <SelectDataWrapper {...this.props}>
            <SelectData
              {...this.props}
              projectId={id}
              id={runId}
              key={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
            />
            {isEnabled("aible-explore") !== true && !isDataSelect && (
              <SelectDataAdvanced {...this.props}>
                {this.renderType(wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id)}
              </SelectDataAdvanced>
            )}
          </SelectDataWrapper>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  removeStep: () => dispatch(blueprintReducer.removeStepById(ownProps.runId, ownProps.blueprintId, ownProps.type)),
  updateOption: (option, value) =>
    dispatch(runReducer.updateWizardOption(ownProps.runId, ownProps?.options?.["selectedTab"], option, value)),

  incrementStep: (index) => dispatch(wizardReducer.incrementStep(ownProps.runId, ownProps.blueprintId, index)),

  increasePriority: (index) => dispatch(blueprintReducer.increasePriority(ownProps.runId, ownProps.blueprintId, index)),
  decreasePriority: (index) => dispatch(blueprintReducer.decreasePriority(ownProps.runId, ownProps.blueprintId, index)),

  updateBlueprintId: (blueprintId, projectId) => {
    dispatch(blueprintReducer.setBlueprint(ownProps.runId, blueprintId));

    if (blueprintId && ownProps.reportLabel === "My Untitled Project") {
      const blueprint =
        blueprintId === undefined
          ? undefined
          : dispatch((dispatch, getState) => blueprintReducer.getBlueprint(getState(), blueprintId));
      if (blueprint?.name) {
        let nextId = ownProps.nextId ? ownProps.nextId : "new";
        dispatch(nextReducer.updateReportLabelAndContentGenerationCollection(nextId, blueprint.name));
      }
    }
    blueprintId === undefined && ownProps.runId === "new"
      ? dispatch(setupReducer.resetSetupToDefault(ownProps.runId, true))
      : dispatch(setupReducer.updateBlueprintId(ownProps.runId, blueprintId));

    if (projectId !== undefined) {
      return dispatch(projectReducer.resetBudget(projectId));
    }
  },

  checkIsEnabledTab: (key, value) =>
    dispatch((dispatch, getState) => wizardReducer.checkIsEnabledTab(getState(), key, value)),

  updateLabel: (label) => dispatch(setupReducer.updateLabel(ownProps.runId, label)),
  updateDescription: (description) => dispatch(setupReducer.updateDescription(ownProps.runId, description)),

  updateIsBYOMModal: (isBYOMModal) => dispatch(setupReducer.updateIsBYOMModal(ownProps.runId, isBYOMModal)),

  updatePanelMode: (panelMode) =>
    dispatch(runReducer.updatePanelMode(ownProps.originalId, ownProps.blueprintId, panelMode)),
  updateIsEditing: (isEditing) => dispatch(blueprintReducer.updateIsEditing(ownProps.blueprintId, isEditing)),
  trainAI: () => dispatch(unifiedProjectReducer.startModelRun(ownProps.id, ownProps.runId, ownProps.blueprintId)),
  updateIsEditBlueprint: (value) => dispatch(unifiedProjectReducer.updateIsEditBlueprint(ownProps.id, value)),
  updateIsBYOMOpen: (isOpen) => dispatch(setupReducer.updateIsBYOMModal(ownProps.id, isOpen)),

  createAndUpdateProject: () => dispatch(nextReducer.createAndUpdateProject(ownProps.nextId, ownProps.runId)),
  copyTransformFromSetup: (datasetId) => dispatch(homeReducer.copyTransformFromSetup(datasetId, ownProps.runId))
});

const mapStateToProps = (state, ownProps) => {
  const isEditBlueprint =
    (ownProps.runId === "new" && ownProps.blueprintId === "new") ||
    blueprintReducer.getIsEditing(state, ownProps.blueprintId);

  const wStep =
    Object.keys(wizardReducer.STEP_TYPE).filter((s) => wizardReducer.STEP_TYPE[s].id === ownProps.type).length > 0
      ? Object.keys(wizardReducer.STEP_TYPE)
          .filter((s) => wizardReducer.STEP_TYPE[s].id === ownProps.type)
          .map((s) => wizardReducer.STEP_TYPE[s])[0]
      : undefined;

  const type = ownProps.type ? ownProps.type : wizardReducer.STEP_TYPE.CHOOSE_DATASET.id;

  const steps = wizardReducer.getSteps(state, ownProps.runId, ownProps.blueprintId);

  const stepIndex = wizardReducer.getStepIndex(state, ownProps.runId, ownProps.blueprintId);

  let isRunning = false;
  let hasModels = false;
  if (ownProps.runId && ownProps.runId !== "new") {
    const runStatus = ownProps.runId && ownProps.runId !== "new" ? runReducer.getStatus(state, ownProps.runId) : null;
    isRunning = runStatus !== "DONE" && runStatus !== "ERROR";

    const models = runReducer.getTransformedSortedModels(state, ownProps.runId);
    const selModel = runReducer.getSelModel(state, ownProps.runId);
    hasModels =
      models !== undefined && selModel !== undefined && models.filter((m) => m.id !== "Current State").length !== 0;
  }

  const selectedDataset = ownProps.selectedDataset
    ? ownProps.selectedDataset
    : setupReducer.getDatasetFromSetup(state, ownProps.runId);

  const aibleMode = wizardReducer.getAibleMode(state, ownProps.runId);

  return {
    blueprintId: ownProps.blueprintId ?? unifiedProjectReducer.getBlueprintId(state, ownProps.id),
    type: type,
    fieldTypes: setupReducer.getFieldTypes(state, ownProps.runId),

    selectedDataset: selectedDataset,

    isFinalStep: steps ? ownProps.index >= steps.length - 1 : false,

    isAdvanced: isEnabled("advanced-wizard"),

    options: runReducer.getWizardOptionsByType(state, ownProps.runId, type),
    advancedDatasetOptions: unifiedProjectReducer.getAdvancedDatasetOptions(state, ownProps.id),

    isNextEnabled: wStep === undefined || wStep.isEnabled === undefined ? true : wStep.isEnabled(state, ownProps),

    stepNum: wStep ? wStep.stepNum : undefined,

    name: wStep ? wStep.name || wStep.id : "",

    tabs: wStep ? wStep.tabs : undefined,

    hideTabs: wStep
      ? typeof wStep.hideTabs === "function"
        ? wStep.hideTabs(state, ownProps)
        : wStep.hideTabs
      : undefined,

    hideNext: wStep ? wStep.hideNext : undefined,
    nextName: wizardReducer.getNextName(state, ownProps.runId, ownProps.blueprintId),
    showBlueprintCreate: wStep ? wStep.showBlueprintCreate : undefined,
    isCreating: wizardReducer.getIsCreating(state),

    isEmptyModel: runReducer.getIsEmptyModel(state, ownProps.runId),

    isShow: true,
    isStep: true,
    originalId: ownProps.runId,
    hasNext: true,

    isHover: wizardReducer.getHoverStep(state) === type,

    stepLength: steps ? steps.length : 0,

    isRunning: isRunning,
    hasModels: hasModels,
    notebookProgress: runReducer.getNotebookProgress(state, ownProps.runId),
    runCost: runReducer.getRunCost(state, ownProps.runId),
    estimatedRunCost: runReducer.getEstimatedRunCost(state, ownProps.runId),

    aibleMode: aibleMode,

    projectId: projectReducer.getProjectIdFromRunId(state, ownProps.runId),

    errors: runReducer.getErrors(state, ownProps.runId),

    panelMode: runReducer.getPanelMode(state, ownProps.runId),

    blueprint: setupReducer.getBlueprintFromSetup(state, ownProps.runId),
    blueprints: viewReducer.getBlueprints(state),

    dataset: setupReducer.getDatasetFromSetup(state, ownProps.runId),
    BYOMURL: setupReducer.getBYOMURL(state, ownProps.runId),
    isBYOMOpen: setupReducer.getIsBYOMModal(state, ownProps.id),

    isForecast: projectReducer.getIsForecastProject(state, ownProps.id),

    isUpdatingProject: nextReducer.getIsUpdatingProject(state, ownProps.nextId),
    innerRunId: projectReducer.getInnerId(state, ownProps.id)
    // title: isAcademicSuccess ? "Requirement Gathering: Cost Ratio" : undefined
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(SelectDataWrapperContainer);
